"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contextColors = exports.caretVariables = void 0;
var __vanilla_filescope__ = _interopRequireWildcard(require("@vanilla-extract/css/fileScope"));
var _css = require("@vanilla-extract/css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
__vanilla_filescope__.setFileScope("src/cssVariables.cjs.css.ts", "@paypalcorp/pp-react-utils");
// Color Family Tokens
var contextColors = exports.contextColors = {
  main: (0, _css.createVar)("contextColors_main"),
  background: (0, _css.createVar)("contextColors_background"),
  hoverMain: (0, _css.createVar)("contextColors_hoverMain"),
  hoverBack: (0, _css.createVar)("contextColors_hoverBack"),
  activeMain: (0, _css.createVar)("contextColors_activeMain"),
  activeBack: (0, _css.createVar)("contextColors_activeBack")
};

// Caret util variables
var caretVariables = exports.caretVariables = {
  caretSize: (0, _css.createVar)("caretVariables_caretSize"),
  //used for setting width and height in baseStyles
  caretLeftOffset: (0, _css.createVar)("caretVariables_caretLeftOffset"),
  //used in positionLeftStyles
  caretRightOffset: (0, _css.createVar)("caretVariables_caretRightOffset"),
  //used in positionRightStyles
  caretBottomOffset: (0, _css.createVar)("caretVariables_caretBottomOffset"),
  //used in positionBottomStyles
  caretTopOffset: (0, _css.createVar)("caretVariables_caretTopOffset"),
  // used in positionTopStyles
  caretCenterOffset: (0, _css.createVar)("caretVariables_caretCenterOffset"),
  //used in positionCenterStyles
  caretSpaceShiftLeft: (0, _css.createVar)("caretVariables_caretSpaceShiftLeft"),
  //used in positionShiftLeftStyles
  caretSpaceShiftRight: (0, _css.createVar)("caretVariables_caretSpaceShiftRight") //used in positionShiftRightStyles
};
__vanilla_filescope__.endFileScope();
